module.exports = function() {
  return new Worker(__webpack_public_path__ + "e41620bdb3ff1bb4536c.worker.js");
};